<lib-input [formControl]="control" (blur)="onBlur()" (keydown.enter)="$event.stopPropagation(); onBlur()"></lib-input>
